import { render, staticRenderFns } from "./MyRecentQrCodes.vue?vue&type=template&id=21e6691e"
import script from "./MyRecentQrCodes.vue?vue&type=script&lang=js"
export * from "./MyRecentQrCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e6691e')) {
      api.createRecord('21e6691e', component.options)
    } else {
      api.reload('21e6691e', component.options)
    }
    module.hot.accept("./MyRecentQrCodes.vue?vue&type=template&id=21e6691e", function () {
      api.rerender('21e6691e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/MyRecentQrCodes.vue"
export default component.exports